import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

const ErrorInfo = props => {
  let errorMessages = []

  if (props.log.params.error) {
      errorMessages.push(
        <li key={0}>
          <b>Error:</b> {props.log.params.error}
        </li>
      )
  }
  if (props.log.params.ltiErrors) {
    if (props.log.params.ltiErrors.fakeOauthKey) {
      errorMessages.push(
        <li key={1}>
          <b>Fake OAuth Key:</b> {props.log.params.ltiErrors.fakeOauthKey}
        </li>
      )
    }
    if (props.log.params.ltiErrors.noEmail) {
      errorMessages.push(
        <li key={2}>
          <b>No Email:</b> {props.log.params.ltiErrors.noEmail}
        </li>
      )
    }
    if (props.log.params.ltiErrors.canvasTestUser) {
      errorMessages.push(
        <li key={3}>
          <b>Canvas Test User:</b> {props.log.params.ltiErrors.canvasTestUser}
        </li>
      )
    }
    if (props.log.params.ltiErrors.noFirstName) {
      errorMessages.push(
        <li key={4}>
          <b>No First Name:</b> {props.log.params.ltiErrors.noFirstName}
        </li>
      )
    }
    if (props.log.params.ltiErrors.noLastName) {
      errorMessages.push(
        <li key={5}>
          <b>No Last Name:</b> {props.log.params.ltiErrors.noLastName}
        </li>
      )
    }
    if (props.log.params.ltiErrors.noUserId) {
      errorMessages.push(
        <li key={6}>
          <b>No User ID:</b> {props.log.params.ltiErrors.noUserId}
        </li>
      )
    }
}

  return (
    <Fragment>
      <h3>Error Info</h3>
      <ul>{errorMessages}</ul>
    </Fragment>
  )
}
export default ErrorInfo

ErrorInfo.propTypes = {
  log: PropTypes.object,
}
